import {useSettingsView} from 'store/Settings';
import {useBudgetStore} from 'store/Budget';
import {futureDaysCount} from './util';

export function useFutureDaysCount(): number {
  const budget = useBudgetStore();
  const settingsView = useSettingsView();
  return futureDaysCount(budget, settingsView);
}
